const newFeature = {
  title: 'Impulsa tu carrera profesional',
  caption1: 'Video presentación',
  caption2: 'Conocimientos y habilidades',
}

export default newFeature
